import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.2987 0.70875C12.9087 0.31875 12.2787 0.31875 11.8887 0.70875L6.99875 5.58875L2.10875 0.69875C1.71875 0.30875 1.08875 0.30875 0.69875 0.69875C0.30875 1.08875 0.30875 1.71875 0.69875 2.10875L5.58875 6.99875L0.69875 11.8887C0.30875 12.2787 0.30875 12.9087 0.69875 13.2987C1.08875 13.6887 1.71875 13.6887 2.10875 13.2987L6.99875 8.40875L11.8887 13.2987C12.2787 13.6887 12.9087 13.6887 13.2987 13.2987C13.6887 12.9087 13.6887 12.2787 13.2987 11.8887L8.40875 6.99875L13.2987 2.10875C13.6787 1.72875 13.6787 1.08875 13.2987 0.70875Z",
		fill: "#1D1D1D"
	})
});
export default SvgClose;
